export default "__VITE_ASSET__CFBKwYtq__"